module.exports = "/images/teachable.png?1fb2f12dca5ba2be782fd9a32afd7587";